export default "__VITE_ASSET__dacb2be4__"